import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import type { FieldError } from 'react-hook-form';
import type { InputBaseProps } from 'src/components/Atoms/InputBase';

// import DoneIcon from '@mui/icons-material/DoneRounded';
import ErrorIcon from '@mui/icons-material/Error';
import HelpIcon from '@mui/icons-material/HelpOutlineOutlined';

// import WarningIcon from '@mui/icons-material/WarningRounded';

import { Tooltip } from 'src/components/Atoms/Tooltip';
import { InputBase } from 'src/components/Atoms/InputBase';
import { InputLabel } from 'src/components/Atoms/InputLabel';
import { InputHelperText } from 'src/components/Atoms/InputHelperText';
import { FormControl } from 'src/components/Molecules/FormControl';
import { styled } from '@mui/material/styles';
type TextInputProps = InputBaseProps & {
  help?: string;
  label?: string;
  showLabel?: boolean;
  hasError?: boolean;
  errorMessage?: FieldError | string;
  showPassword?: boolean;
};
const StyledErrorIcon = styled(ErrorIcon)(({
  theme
}) => ({
  width: theme.fonts.size.lg,
  height: theme.fonts.size.lg,
  fill: theme.colors.surface['error-primary']
}));
const StyledHelpIcon = styled(HelpIcon)(({
  theme
}) => ({
  '&.MuiSvgIcon-root': {
    color: theme.colors.icon.primary,
    fontSize: theme.fonts.size.sm,
    cursor: 'pointer'
  }
}));
const TextInput: React.FC<TextInputProps> = t0 => {
  const $ = _c(33);
  let errorMessage;
  let hasError;
  let help;
  let id;
  let label;
  let placeholder;
  let props;
  let showPassword;
  let t1;
  let value;
  if ($[0] !== t0) {
    ({
      label,
      showLabel: t1,
      id,
      value,
      placeholder,
      help,
      showPassword,
      hasError,
      errorMessage,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = errorMessage;
    $[2] = hasError;
    $[3] = help;
    $[4] = id;
    $[5] = label;
    $[6] = placeholder;
    $[7] = props;
    $[8] = showPassword;
    $[9] = t1;
    $[10] = value;
  } else {
    errorMessage = $[1];
    hasError = $[2];
    help = $[3];
    id = $[4];
    label = $[5];
    placeholder = $[6];
    props = $[7];
    showPassword = $[8];
    t1 = $[9];
    value = $[10];
  }
  const showLabel = t1 === undefined ? true : t1;
  let t2;
  if ($[11] !== help || $[12] !== id || $[13] !== label || $[14] !== showLabel) {
    t2 = showLabel && label && <InputLabel shrink={true} htmlFor={id}>{label}{help && <Tooltip title={help} placement="top"><StyledHelpIcon /></Tooltip>}</InputLabel>;
    $[11] = help;
    $[12] = id;
    $[13] = label;
    $[14] = showLabel;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  const t3 = showPassword ? "text" : props.type;
  let t4;
  if ($[16] !== hasError) {
    t4 = hasError && {
      endAdornment: <StyledErrorIcon />
    };
    $[16] = hasError;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== hasError || $[19] !== id || $[20] !== placeholder || $[21] !== props || $[22] !== t3 || $[23] !== t4 || $[24] !== value) {
    t5 = <InputBase value={value} placeholder={placeholder} hasError={hasError} id={id} {...props} type={t3} {...t4} />;
    $[18] = hasError;
    $[19] = id;
    $[20] = placeholder;
    $[21] = props;
    $[22] = t3;
    $[23] = t4;
    $[24] = value;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  let t6;
  if ($[26] !== errorMessage || $[27] !== hasError) {
    t6 = hasError && <InputHelperText error={hasError}>{typeof errorMessage === "string" ? errorMessage : errorMessage?.message}</InputHelperText>;
    $[26] = errorMessage;
    $[27] = hasError;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  let t7;
  if ($[29] !== t2 || $[30] !== t5 || $[31] !== t6) {
    t7 = <FormControl variant="standard">{t2}{t5}{t6}</FormControl>;
    $[29] = t2;
    $[30] = t5;
    $[31] = t6;
    $[32] = t7;
  } else {
    t7 = $[32];
  }
  return t7;
};
export default TextInput;
export type { TextInputProps };